import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomImageUpload from "../../component/CustomImageUpload";

const addEndpoint = ApiEndpoints.clientLogo.Create;

export default function AddClientLogo() {
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    alt_logo: "",
    logo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviewImage(URL.createObjectURL(file));

      // Update the postData state
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      // Create a new FormData instance
      const payload = new FormData();

      // Add all form fields except the image
      Object.keys(formData).forEach((key) => {
        if (key !== "logo") {
          payload.append(key, formData[key]);
        }
      });

      // Append the image field if it exists
      if (formData.logo) {
        payload.append("logo", formData.logo);
      }

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", addEndpoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.error === true) {
          toast.error(response.message)
        } else {
          toast.success(response.message)
          navigate("/client-logos");
        }
      } catch (error) {
        console.error("Error updating logo:", error);
      }
    },
    [formData, navigate]
  );

  const pagename = {
    name: 'Logo Management',
    user: 'Admin',
    innerpage: 'Logo Management / Logo / Add Logo'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="logoAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Image (160 x  72 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="logo"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previewImage}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Alt Image<small>*</small></label>
                  </div>
                  <input type="text" name="alt_logo" onChange={handleChange} className="form-control" required />
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="logoAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
